const MODULE_NAME = 'fulcrum/container/Project/LifecycleSection'

/*const LIFECYCLE_STATES = [
  initialized,
  draft,
  pre_approval,
  pending_approval,
  kickoff,
  design_review,
  qualification,
  mass_production,
  end_of_life,
  cancelled,
  on_hold
]*/

const FETCH_PROJECT_WORKFLOW_DETAILS = MODULE_NAME + '/FETCH_PROJECT_WORKFLOW_DETAILS'
const FETCH_PROJECT_WORKFLOW_DETAILS_START = MODULE_NAME + '/FETCH_PROJECT_WORKFLOW_DETAILS_START'
const FETCH_PROJECT_WORKFLOW_DETAILS_SUCCESS = MODULE_NAME + '/FETCH_PROJECT_WORKFLOW_DETAILS_SUCCESS'
const FETCH_PROJECT_WORKFLOW_DETAILS_ERROR = MODULE_NAME + '/FETCH_PROJECT_WORKFLOW_DETAILS_ERROR'

const POST_WORKFLOW_STATE = MODULE_NAME + '/POST_WORKFLOW_STATE'
const POST_WORKFLOW_STATE_START = MODULE_NAME + '/POST_WORKFLOW_STATE_START'
const POST_WORKFLOW_STATE_SUCCESS = MODULE_NAME + '/POST_WORKFLOW_STATE_SUCCESS'
const POST_WORKFLOW_STATE_ERROR = MODULE_NAME + '/POST_WORKFLOW_STATE_ERROR'

const UPDATE_STATE_TO_CHANGE_TO = MODULE_NAME + '/UPDATE_STATE_TO_CHANGE_TO'
const RESET_STATE_TO_CHANGE_TO = MODULE_NAME + '/RESET_STATE_TO_CHANGE_TO'

const CANCELLED_STATE = 'cancelled'
const DELETED_STATE = 'deleted'

const DIALOG_INACTIVE = 'inactive'
const DIALOG_CANCELLED = CANCELLED_STATE
const DIALOG_DELETED = DELETED_STATE

export {
  MODULE_NAME,
  FETCH_PROJECT_WORKFLOW_DETAILS,
  FETCH_PROJECT_WORKFLOW_DETAILS_START,
  FETCH_PROJECT_WORKFLOW_DETAILS_ERROR,
  FETCH_PROJECT_WORKFLOW_DETAILS_SUCCESS,
  POST_WORKFLOW_STATE,
  POST_WORKFLOW_STATE_START,
  POST_WORKFLOW_STATE_ERROR,
  POST_WORKFLOW_STATE_SUCCESS,
  UPDATE_STATE_TO_CHANGE_TO,
  RESET_STATE_TO_CHANGE_TO,
  DIALOG_INACTIVE,
  DIALOG_CANCELLED,
  DIALOG_DELETED,
  CANCELLED_STATE,
  DELETED_STATE
}
